import React from "react";
import { Dialog, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import KpiModal from "../../pages/ManualEntry/KpiModal";
import { UseUserId, UseIsAdmin, UseCompanyId } from "../../hooks/auth";
import Icon from "../Icons/Icon";
import SoftBox from "../SoftBox";
import QuickCapture from "../QuickCapture/QuickCapture";

const PopUpModal = ({ kpi, disabled, ...props }) => {
  const [open, setOpen] = React.useState(false);
  const [quickCaptureOpen, setQuickCaptureOpen] = React.useState(false);
  const navigate = useNavigate();
  const userId = UseUserId();
  const isAdmin = UseIsAdmin();
  const companyId = UseCompanyId();

  const isStandaloneQuickCapture = kpi.requiredInputs?.length === 1
    && kpi.requiredInputs[0].type === "quick-capture"
    && kpi.requiredInputs[0].value === "photo";

  const handleOpen = () => {
    if (disabled) return;
    if (isAdmin) {
      navigate(`/scorekeeper?kpi=${kpi._id}`);
      return;
    }
    if (isStandaloneQuickCapture) {
      setQuickCaptureOpen(true);
      return;
    }
    props.onOpen?.();
    setOpen(true);
  };
  const handleClose = () => {
    props.onClose?.();
    setOpen(false);
  };

  const handleSave = () => {
    handleClose();
    props.onSave?.();
  };

  return (
    <>
      <SoftBox 
        onClick={kpi.integrationId || kpi.metricType === "anchor" ? () => { navigate(isAdmin ? `/scorekeeper?kpi=${kpi._id}` : `/scorekeeper/timeline?kpi=${kpi._id}&player=true`); } : handleOpen}
        sx={{ height: "100%", cursor: "pointer" }}>
        {props.children}
      </SoftBox>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="xs"
        sx={{
          // width: { xs: "100vw", sm: "60vw" },
          ".MuiPaper-root": {
            borderRadius: "24px",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.70) 0%, rgba(255,255,255,0.60) 100%)",
            boxShadow:
              "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
            border: "1px solid rgba(255,255,255,0.6)",
            backdropFilter: "blur(18px) saturate(160%)",
            WebkitBackdropFilter: "blur(18px) saturate(160%)",
            padding: { mini: "1rem", md: "1.5rem" },
          },
          ".MuiDialog-paperFullWidth": {
            width: {
              mini: "100%",
              sm: "100%"
            }
          }
        }}
      >
        <SoftBox
          sx={{
            display: "grid",
            gridTemplateColumns: !kpi.integrationId ? "1fr 1fr" : "1fr",
            gap: 2,
            alignItems: "stretch", // Change from "center" to "stretch"
            justifyContent: "center",
            "& > *": {
              gridColumn: !kpi.integrationId ? "auto" : "1",
            },
            "& div:nth-child(2)": {
              marginTop: {
                mini: !kpi.integrationId ? "16px" : 0,
                sm: "unset"
              }
            }
          }}
        >
            <KpiModal
              kpi={kpi}
              userId={userId}
              userPoints={kpi?.amount ?? 0}
              onClose={handleClose}
              onSave={handleSave}
            >
              {!kpi.integrationId && (
                <SoftBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center", // Add this line
                    borderRadius: 2,
                    padding: { mini: "1rem", md: "2rem" },
                    boxShadow: 2,
                    background: "rgba(15,23,42,0.03)",
                    border: "1px solid rgba(15,23,42,0.10)",
                  }}
                >
                  <Icon iconKey="add" size={3} transparent={true} round />
                  <Typography
                    className="mt-2"
                    variant="body2"
                    sx={{
                      color: "#0F172A",
                      lineHeight: "normal",
                      textAlign: "center"
                    }}
                  >
                    Add {kpi.title ?? "KPI"}
                  </Typography>
                </SoftBox>
              )}
            </KpiModal>

          <SoftBox
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 2,
              padding: { mini: "1rem", md: "2rem" },
              boxShadow: 2,
              cursor: "pointer",
              background: "rgba(15,23,42,0.03)",
              border: "1px solid rgba(15,23,42,0.10)",
              marginTop: "0px !important",
            }}
            onClick={() => {
              navigate(isAdmin ? `/scorekeeper?kpi=${kpi._id}` : `/scorekeeper/timeline?kpi=${kpi._id}&player=true`);
            }}
          >
            <Icon iconKey="list" size={3} transparent={true} round />
            <Typography variant="body2" className="mt-2" sx={{ color: "#0F172A" }}>
              See Details
            </Typography>
          </SoftBox>
        </SoftBox>
      </Dialog>
      <QuickCapture
        kpi={kpi}
        userId={userId}
        companyId={companyId}
        open={quickCaptureOpen}
        onClose={() => setQuickCaptureOpen(false)}
      />
    </>
  );
};

export default PopUpModal;
